import { render, staticRenderFns } from "./RefundGoodsItem.vue?vue&type=template&id=b0ccdcbe&scoped=true&"
import script from "./RefundGoodsItem.vue?vue&type=script&lang=js&"
export * from "./RefundGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./RefundGoodsItem.vue?vue&type=style&index=0&id=b0ccdcbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ccdcbe",
  null
  
)

export default component.exports